// extracted by mini-css-extract-plugin
export var csatScore = "_mr-5";
export var header = "_mr-1";
export var panelWrapper = "_mr-2";
export var postPreview = "_mr-3";
export var rightContent = "_mr-0";
export var wrappingText = "_mr-4";